import { Box, Text } from '@shared/components';

export interface NavigatorLinkProps {
  label: number;
  onClick: (value: number) => void;
  selected: boolean;
}

export default function NavigatorLink(props: Readonly<NavigatorLinkProps>) {
  const { label, onClick, selected: isSelected } = props;

  return (
    <Box
      component='button'
      onClick={() => onClick(label)}
      sx={(theme) => ({
        cursor: 'pointer',
        textDecoration: 'none',
        color: theme.palette.text.primary,
        backgroundColor: isSelected ? 'inherit' : theme.palette.grey[100],
        border: '1px solid',
        borderColor: isSelected ? theme.palette.primary.main : 'transparent',
        borderRadius: theme.shape.rounded(1),
        width: '28px',
        aspectRatio: '1 / 1',
        textAlign: 'center',
        p: theme.spacing(0),
      })}
    >
      <Text component='span' variant='caption'>
        {label}
      </Text>
    </Box>
  );
}
